const ITEMS = ["Lawnmowing", "Gutter Cleaning", "Pressure Washing", "Weeding", "Fence Repair", "Painting", "No Online Payment", "Pay At Job Site"];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-amber-500/20 bg-[#111827] py-5">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-condensed font-bold uppercase tracking-widest text-2xl sm:text-3xl text-slate-500/80 px-6">
                  {item}
                </span>
                <span className="w-2 h-2 rotate-45 bg-amber-500 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
